import React from 'react';
import { t } from '@lingui/macro';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { CHARGING_OBJECTS_LOAD_LEGEND, CHARGING_PROPOSALS_PLAN_LEGEND } from '../../../constants/legends';
import styles from '../FilterSidebar.module.css';

// DA-13733: легенда загрузки зарядных объектов. Тогл «Действующие объекты» с раздельными тоглами
// подрядчиков (фильтр слоя, см. chargingObjectsFilter) и тогл предложений по развитию сети.
// В легенде оставлен только согласованный план; варианты walk и scooter пока живут в данных.
const Toggle = ({ label, name, checked, onChange, sub }) => (
    <div
        className={sub ? null : styles.legHead}
        // Тоглы прижаты к правому краю; подписи подрядчиков — с отступом под заголовком,
        // правый отступ как у legHead (10px), чтобы бегунки встали в одну колонку
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '8px',
            ...(sub ? { padding: '0 10px 6px 24px' } : {}),
        }}
    >
        {label}
        {/* flexShrink: 0 — длинная подпись иначе сжимает гнездо, и бегунок вылезает за него */}
        <label
            className={styles.switch}
            style={{ flexShrink: 0 }}
            data-export-omit=""
        >
            <input
                type='checkbox'
                name={name}
                checked={checked}
                onChange={({ target: { checked: value } }) => onChange(name, value)}
            />
            <span className={classnames(styles.sliderRound, styles.slider)} />
        </label>
    </div>
);
const ChargingObjectsLoadLegendComponent = ({
    chargingObjects = true,
    chargingAksel = true,
    chargingInnovat = true,
    chargingProposals,
    onChangeMapFilters,
}) => (
    <div>
        <Toggle
            label={t`Действующие объекты`}
            name='chargingObjects'
            checked={chargingObjects}
            onChange={onChangeMapFilters}
        />
        {chargingObjects && (
            <>
                <Toggle
                    sub
                    label={t`Аксель`}
                    name='chargingAksel'
                    checked={chargingAksel}
                    onChange={onChangeMapFilters}
                />
                <Toggle
                    sub
                    label={t`Инноватт`}
                    name='chargingInnovat'
                    checked={chargingInnovat}
                    onChange={onChangeMapFilters}
                />
                <LegendRenderer config={CHARGING_OBJECTS_LOAD_LEGEND} />
                <div style={{ padding: '0 10px 10px', fontSize: '12px', lineHeight: '15px', opacity: 0.75 }}>
                    {t`Загрузка зарядных объектов: оборот от потолка 7 зарядов на слот (размер — число слотов, тёмная обводка — оценка по модели; наведите на объект — покажется его зона обслуживания: оранжевая — 80% замен, устойчивый спрос; жёлтая — остальные 20%, остаточный)`}
                </div>
            </>
        )}
        <Toggle
            label={t`Согласованный план развития сети`}
            name='chargingProposals'
            checked={chargingProposals}
            onChange={onChangeMapFilters}
        />
        {chargingProposals && <LegendRenderer config={CHARGING_PROPOSALS_PLAN_LEGEND} />}
    </div>
);
const ConnectedComponent = connect(
    ({ mapFilters: { chargingObjects, chargingAksel, chargingInnovat, chargingProposals } }) => ({ chargingObjects, chargingAksel, chargingInnovat, chargingProposals }),
    { onChangeMapFilters }
)(ChargingObjectsLoadLegendComponent);
// Второй аргумент — id слоя (filterIds сверяет по layer.id, не по label).
export const ChargingObjectsLoadLegend = withDisplayedLayersCheck(
    ConnectedComponent,
    'Загрузка зарядных объектов'
);
